define('app/views/google-map',['require','json!../map-style.json','./baseview'],function(require){

  var MapStyle = require('json!../map-style.json');
  var BaseView = require('./baseview');

  var GoogleMap = BaseView.extend({

    view: 'google-map',

    markers: [],
    map: null,
    mapOptions: {},

    defaults: {
      centerLatitude: '',
      centerLongitude: '',
      zoom: 8
    },

    initialize: function(options){
      BaseView.prototype.initialize.call(this, options);

      _.bindAll(this, 'onGoogleMaps');

      $('.marker', this.$el).each(function(){
        this.markers.push($(this).data());
      });

      require(['async!http://maps.google.com/maps/api/js?sensor=false'], this.onGoogleMaps);
    },

    setMarkers: function(markers){
      this.cleanMarkers();
      if(_.isArray(markers) && markers.length){
        this.markers = markers;
      } else {
        this.markers = [{ latitude: this.options.centerLatitude, longitude: this.options.centerLongitude }];
      }
      this.drawMarkers();
    },

    getMarkers: function(){
      return this.markers;
    },

    cleanMarkers: function(){
      _.each(this.markers, function(marker){
        if(marker.googleMarker) marker.googleMarker.setMap(null);
      });
    },

    drawMarkers: function(){
      var _self = this;
      _.each(this.markers, function(marker){
        var position = new google.maps.LatLng(marker.latitude, marker.longitude);
        var markerOptions = $.extend({}, { map: _self.map, position: position, icon: marker.icon }, _self.options.marker);
        marker.googleMarker = new google.maps.Marker(markerOptions);
      });
    },

    onGoogleMaps: function(){
      this.mapOptions = _.extend({}, this.options);
      this.mapOptions.center = new google.maps.LatLng(this.options.centerLatitude, this.options.centerLongitude);
      this.mapOptions.styles = MapStyle;

      this.map = new google.maps.Map($("#map-container", this.$el)[0], this.mapOptions);

      this.setMarkers(this.markers);

      this.trigger(BaseView.AFTER_LOADED, this);
    },

    onResize: function(e){
      if(this.map && google && google.maps){
        google.maps.event.trigger(this.map, 'resize');
        this.map.setCenter(this.mapOptions.center);
      }
    }

  });

  return GoogleMap;

});
